enum ImageAndTextCtaBtnPosition {
  LEFT = 'btn-alignment-left',
  RIGHT = 'btn-alignment-right',
  CENTER = 'btn-alignment-center',
}
enum ImageAndTextDirection {
  LEFT_TEXT_RIGHT_IMAGE = 'desktop-left-text-right-image',
  LEFT_IMAGE_RIGHT_TEXT = 'desktop-left-image-right-text',
  TOP_TEXT_BOTTOM_IMAGE = 'desktop-top-text-bottom-image',
  TOP_IMAGE_BOTTOM_TEXT = 'desktop-top-image-bottom-text',
}
export { ImageAndTextCtaBtnPosition, ImageAndTextDirection };
